import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=f90ca762&scoped=true&"
import script from "./Multiselect.vue?vue&type=script&lang=ts&"
export * from "./Multiselect.vue?vue&type=script&lang=ts&"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=f90ca762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90ca762",
  null
  
)

export default component.exports